import React from "react";
import { Button, Collapse, Typography } from "antd";
import { CloseOutlined } from "@ant-design/icons";

const { Text } = Typography;

export interface ConfigPanelShellProps {
    title: string;
    onClose: () => void;
    helpContent?: { title?: string; body: string };
    children: React.ReactNode;
    footer?: React.ReactNode;
}

export const ConfigPanelShell: React.FC<ConfigPanelShellProps> = ({
    title,
    onClose,
    helpContent,
    children,
    footer,
}) => {
    return (
        <div className="trigger-rule-config-panel d-flex flex-column flex-1 min-h-0 h-100 overflow-hidden">
            <div className="trigger-rule-config-panel-header d-flex align-items-center justify-content-between flex-shrink-0">
                <Text className="hs-fw-600 hs-fs-14 hs-color-BlackRussian">
                    {title}
                </Text>
                <Button
                    type="text"
                    onClick={onClose}
                    aria-label="Close"
                    icon={<CloseOutlined />}
                />
            </div>
            <div className="trigger-rule-config-panel-body flex-fill min-h-0 overflow-y-auto overflow-x-hidden py-3 px-3">
                {children}
            </div>
            {helpContent ? (
                <div className="flex-shrink-0">
                    <Collapse
                        ghost
                        className="trigger-rule-config-panel-help-collapse hs-border-top-light rounded-3 p-1"
                        size="small"
                        items={[
                            {
                                key: "how-it-works",
                                label: (
                                    <span className="hs-fw-600 hs-fs-12 hs-color-light-grey-2">
                                        {`What does this configuration do ?`}
                                    </span>
                                ),
                                children: <Text className="hs-fs-12 hs-color-light-grey-2 d-block">{helpContent.body}</Text>,
                            },
                        ]}
                    />
                </div>
            ) : null}
            {footer ? <div className="flex-shrink-0">{footer}</div> : null}
        </div>
    );
};
